module.exports = __webpack_public_path__ + "static/media/introFirst.03d12976.png";